module.exports = __webpack_public_path__ + "static/img/Regular-active.2f4a28a2.svg";